import React, { Component } from 'react'
import { AppSwitcher, SwxTheme } from 'swx-atomic-component-lib'
import themeUtil from '../utils/themeUtil'
import i18n from '../../i18n'

class AppSwitcherImpl extends Component {
  constructor (props) {
    super(props)
    this.state = {
      disabled: true,
      isSysAdmin: false,
      isAppDown: false
    }
  }

  componentDidMount () {
    this.props.verifyAuthorization(this.props.data.client_id).then(res => {
      this.props.checkAllAppsVerified()
      const allowedHttpStatusCode = [200, 401, 403]
      this.setState({
        disabled: !res.data.success,
        isSysAdmin: !!res.data.isSysAdmin,
        isAppDown: !!((res.data.code && !allowedHttpStatusCode.includes(res.data.code)))
      })
    }).catch(() => this.props.checkAllAppsVerified())
  }

  render () {
    const { data } = this.props
    data.disabled = this.state.disabled
    data.isAppDown = this.state.isAppDown
    data.isSysAdmin = this.state.isSysAdmin
    const bgColor = this.state.disabled ? SwxTheme.palette.white : themeUtil[data.theme || 'primary'].bgColor
    let textColor = this.state.disabled ? SwxTheme.palette['secondary-dark'] : themeUtil[data.theme || 'primary'].textColor
    const borderColor = data.client_id.toLowerCase() === 'swxhelp' || this.state.disabled ? SwxTheme.palette['secondary-dark'] : bgColor
    let buttonLabel = data.client_id.toLowerCase() !== 'swxhelp' ? i18n.formatString(i18n.appLauncher.launchButton, { name: data.name }) : data.name

    let articleBgColor = SwxTheme.palette.white
    let articleBorderColor = SwxTheme.palette.g500
    let articleSeparatorColor = SwxTheme.palette.g400
    let description = ''
    let imgUrl = window.location.origin + '/symbol-color.svg'

    if (this.state.disabled) {
      buttonLabel = i18n.appLauncher.learnMore
      articleBgColor = SwxTheme.palette.g200
      imgUrl = window.location.origin + '/symbol-black.svg'

      if (this.state.isAppDown) {
        buttonLabel = i18n.appLauncher.backSoon
        articleBgColor = '#ffecec'
        articleBorderColor = '#c63e3e'
        articleSeparatorColor = articleBorderColor
        description = i18n.appLauncher.undergoingMaintenance
        textColor = SwxTheme.palette.black
        data.theme = 'white'
        imgUrl = window.location.origin + '/symbol-white.svg'
      }
    }

    return (
      <AppSwitcher
        key={data.client_id}
        customStyle={`
          article {
            background-color: ${articleBgColor};
            border: 1px solid ${articleBorderColor};
            > div:first-child {
              border-right: 1px solid ${articleSeparatorColor};
            }
          }
          button { 
            margin-top: 0; 
            display: block; 
            background-color: ${bgColor};
            border: 1px solid ${borderColor};
            color: ${textColor};
            &:hover {
              color: ${SwxTheme.palette.white};
            }
            &:focus {
              outline: 0;
            }
            &:active {
              background-color: ${bgColor};
              border: 2px solid ${borderColor};
              color: ${textColor};
            }
            &:focus {
              background-color: ${bgColor};
              border: 2px solid ${borderColor};
              color: ${textColor};
            }
          }
          button.admin-btn {
            color: #000000;
            background-color: transparent;
            border: none;
            &:hover {
              color: #3879c0;
              background-color: transparent;
            }
          }
          font-size: ${SwxTheme.component.general.fontSize};
        `}
        mb={SwxTheme.sizing.x3}
        rounded
        title={data.name}
        subTitle={data.description}
        description={description}
        showAdminBtn={!!data.isSysAdmin && !!data.sysadmin_url}
        action={{
          label: buttonLabel,
          buttonProps: {
            onClick: (btn, e) => this.props.onClick(data, e)
          },
          adminButtonProps: {
            onClick: () => { window.location.href = data.sysadmin_url },
            title: 'Manage application in Admin Portal'
          }
        }}
        iconUrl={imgUrl}
      />
    )
  }
}

export default AppSwitcherImpl
